import { Notification, Message, MessageBox } from 'element-ui'
import { ElNotificationComponent } from 'element-ui/types/notification'
import { ElMessageComponent } from 'element-ui/types/message'
import { vue } from '@/main'

/**
 * 成功提示, 用于系统被动提示
 * @param title 提示信息
 */
export function notify(title: string): ElNotificationComponent
/**
 * 失败提示, 用于系统被动提示
 * @param title 提示信息
 * @param error 错误
 */
export function notify(title: string, error: Error): ElNotificationComponent
export function notify(title: string, error?: Error) {
  return error instanceof Error
    ? Notification.error({ title, message: error.message })
    : Notification.success(title)
}

export function warning(title: string, message: string) {
  Notification.error({ title, message })
}
/**
 * 成功提示, 用于操作后提示
 * @param title 提示信息
 */
export function alert(title: string): ElMessageComponent
/**
 * 失败提示, 用于操作后提示
 * @param title 提示信息
 * @param error 错误
 */
export function alert(title: string, error: Error): ElMessageComponent
export function alert(title: string, error?: Error) {
  return error instanceof Error
    ? Message.error({ message: createAlertVNode(title, error.message) })
    : Message.success(title)
}

function createAlertVNode(title: string, message: string) {
  const h = vue.$createElement

  return h('div', { class: ['el-message__content'] }, [
    h('p', { class: ['el-alert__title', 'is-bold'] }, title),
    h(
      'p',
      { class: ['el-alert__description'], style: { 'font-size': '12px' } },
      message
    )
  ])
}

export const comfirm = MessageBox.confirm
export const prompt = MessageBox.prompt
